import ActionTypes from '../constants/ActionTypes';

const updatePointSystem = (boardId, data) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE,
  payload: {
    boardId,
    data,
  },
});

updatePointSystem.success = (pointSystem) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE__SUCCESS,
  payload: {
    pointSystem,
  },
});

updatePointSystem.failure = (boardId, error) => ({
  type: ActionTypes.POINT_SYSTEM_UPDATE__FAILURE,
  payload: {
    boardId,
    error,
  },
});

export default {
  updatePointSystem,
};

